import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { figma } from '../theme/figmaTokens';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
        backgroundColor: figma.pageBg,
      }}
    >
      <CircularProgress size={40} sx={{ color: figma.cyan }} />
      <Typography variant="body1" sx={{ color: figma.textMuted }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
